import MidiEffect from './MidiEffect.js';
import {AbstractParameter} from 'parameters/AbstractParameter.js';

/**
 * Limits the number of triggers
 */
class LimitEffect extends MidiEffect {
    constructor(sequencerEngine) {
        super('Limit', sequencerEngine);

        // parameters for the arpeggiator
        this.limitParameter = new AbstractParameter(
            'limit', this, (o, x) => x,
           {
               documentation: "The maximum number of notes that can be triggered on a given step.",
                min: 0,
                max: 16,
                unit: '',
                defaultValue: 1
            });
        this.registerParameter(this.limitParameter);
    }

    getVisualizedParameters() {
        return [this.limitParameter];
    }

    getText() {
        return this.limitParameter.get();
    }

    get documentation() {
        return "Limits the number of notes that can be triggered on a given step.";
    }

    get limit() {
        return this.limitParameter.get();
    }

    output() {
        return this.triggers.slice(0, this.limit);
    }

    getCopy(track, ignoreId=true) {
        let fx = new LimitEffect(track);
        fx.fromJson(this.getJson(), ignoreId);
        return fx;
    }
}

export default LimitEffect;
